<template>
  <b-slider
    v-model="sliderValue"
    class="is-primary"
    :min="0" :max="2"
    v-bind:custom-formatter="formatHmlTicks"
  >
    <b-slider-tick title="Not applied" :value="0" :key="0">&#x25CE;</b-slider-tick>
    <b-slider-tick title="Applied" :value="1" :key="1">&#x25D0;</b-slider-tick>
    <b-slider-tick title="Most important" :value="2" :key="2">&#x25CF;</b-slider-tick>
  </b-slider>
</template>

<script>
  import Vue from 'vue';

  export default {
    data() {
      return {
      }
    },
    props: {
      screen: Object,
    },
    computed: {
      sliderValue: {
        get: function() {
          // In the case that someone else (portfolio manager) has edited the HML values after the fact and we no longer
          // have a direct mapping of the userPercentiles into our HML values, we can retain the display here by just
          // setting the HML based on the underlying value range. This won't be updated on save without an explicit change
          // to the slider, so presumably in that case the advisor is back at the drawing board anyhow.

          if (this.screen.userPercentile === 0) {
            return 0;
          }
          if (this.screen.userPercentile > 0 && this.screen.userPercentile <= 10) {
            return 1;
          }
          return 2;
        },
        set: function(value) {
          let values = {
            0: 0,
            1: 10,
            2: 50,
          }
          this.$emit('change', values[value]);
        }
      }
    },
    methods: {
      formatHmlTicks: function(val) {
        const vals = {
          0: 'Not applied',
          1: 'Applied',
          2: 'Most important',
        }
        return vals[val];
      },
    },
    watch: {
    },
    mounted: function() {
    },
    created: function() {

    }
  }
</script>

<style lang="scss">
</style>
